module.exports = __webpack_public_path__ + "static/media/203.b8a3c52d.jpg";